import EventInvoicesHtml from './event-invoices.html';

export function EventInvoicesDirective () {
  return {
    controller : 'EventInvoicesCtrl',
    restrict   : 'E',
    templateUrl: EventInvoicesHtml,
    scope      : {
      event         : '=',
      invoices      : '=',
      jobStatusTypes: '='
    }
  };
}